import { Information } from "@faire/slate/icons/Information";
import { Tooltip as SlateTooltip } from "@faire/web/slate-deprecated/Tooltip";
import { PortalTooltip } from "@faire/web/slate-deprecated/Tooltip/PortalTooltip";
import React from "react";

export const Tooltip: React.FC<
  React.PropsWithChildren<{ target?: React.ReactNode }>
> = ({ target, children }) => {
  return (
    <PortalTooltip
      tooltipMainAxisOffset={-4}
      tooltipCrossAxisOffset={-4}
      tooltipZIndex={10000}
      placement="top"
      tooltip={
        <SlateTooltip targetNode={<></>} isOpen>
          {children}
        </SlateTooltip>
      }
    >
      {target ?? <Information fontSize="16px" />}
    </PortalTooltip>
  );
};
